<!-- [팝업] 타겟 경로 선택 -->
<template>
  <b-modal
    v-model="showActionRouteSelect"
    cancel-variant="outline-secondary"
    centered
    ok-title="적용"
    cancel-title="취소"
    size="lg"
    title="타겟 경로 선택"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="submit()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <b-row
      class="mt-25"
      style="border-bottom: 1px solid #ebe9f1;"
    >
      <b-col cols="12">
        <b-form-checkbox
          v-model="selectAll"
          class="mb-1"
          style="width: 120px"
          @change="changeSelectAll()"
        >
          전체 경로
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="12">
        <b-form-checkbox-group
          v-model="selects"
          value-field="code"
          text-field="label"
          :disabled="selectAll"
        >
          <b-form-checkbox
            v-for="type in routeOptionsCode"
            :key="type.code"
            :value="type.code"
            class="mb-25 mr-3"
            style="width: 140px"
          >
            {{ type.label }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
  },

  props: {
    showActionRouteSelect: {
      type: Boolean,
      required: true,
    },
    codes: {
      type: Object,
      required: true,
    },
    selectedValue: {
      type: String,
      required: false,
      default: null,
    },
    actionType: {
      type: Number,
      default: 1,
    },
  },

  setup(props, { emit }) {
    watch(
      () => props.showActionRouteSelect,
      newVal => {
        if (newVal) {
          selects.value = []
          selectAll.value = false

          if (props.selectedValue && props.selectedValue.length > 0) {
            if (props.selectedValue.toString() === '0') selectAll.value = true
            else selects.value = props.selectedValue.split(',').map(Number)
          }
        }
      },
    )

    const toast = useToast()
    const selects = ref([])
    const selectAll = ref(false)

    const routeOptionsCode = computed(
      () => {
        // 컨텐츠 열람 계열 → postViewerRouteType (1=레거시, 11=ContentViewer)
        if (props.actionType === 1 || props.actionType === 11) {
          return props.codes.postViewerRouteType.filter(x => x.code !== 0) || []
        }
        // 팝업 반응 계열 → popupNonClickerRouteType (2=레거시, 21=PopupClicker, 22=PopupIgnorer)
        if (props.actionType === 2 || props.actionType === 21 || props.actionType === 22) {
          return props.codes.popupNonClickerRouteType.filter(x => x.code !== 0) || []
        }
        return []
      },
    )

    const changeSelectAll = () => {
      if (selectAll.value) {
        selects.value = []
      }
    }

    const close = () => {
      emit('close')
    }

    const submit = () => {
      if (!selectAll.value && selects.value.length === 0) {
        toast({
          component: ToastificationContent,
          props: {
            title: '경로를 한 개 이상 선택하세요',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }

      const retVal = []

      if (selectAll.value) {
        retVal.push({ code: '0', label: '전체 경로' })
      } else {
        const filts = routeOptionsCode.value.filter(el => selects.value.indexOf(el.code) > -1)

        if (filts.length) {
          filts.forEach(el => {
            retVal.push(el)
          })
        }
      }

      emit('close', retVal)
    }

    return {
      changeSelectAll,
      close,
      submit,
      selects,
      selectAll,
      routeOptionsCode,
    }
  },
}
</script>
